import { FC } from 'react';

import { BadgeCheck, LayoutPanelTop, Rocket } from 'lucide-react';

const benefits = [
    {
        icon: Rocket,
        title: 'Пріоритет у каталозі',
        description:
            'Premium-пропозиція піднімається вище та показується на першій сторінці каталогу.',
    },
    {
        icon: LayoutPanelTop,
        title: 'Окрема premium-сторінка',
        description:
            'Пропозиція зʼявляється в окремому каталозі активних premium-пропозицій.',
    },
    {
        icon: BadgeCheck,
        title: 'Помітне виділення',
        description:
            'На сторінці товару пропозиція показується вище за звичайні та має premium-позначку.',
    },
];

export const PremiumBenefits: FC = () => (
    <section
        aria-labelledby="premium-benefits-title"
        data-testid="premium-benefits"
    >
        <div className="mb-3">
            <h2 id="premium-benefits-title" className="text-xl font-semibold">
                Що дає premium-пропозиція
            </h2>
        </div>

        <div
            className="grid overflow-hidden rounded-2xl border bg-card sm:grid-cols-3 sm:divide-x"
            data-testid="premium-benefits-grid"
        >
            {benefits.map((benefit) => {
                const Icon = benefit.icon;

                return (
                    <div
                        key={benefit.title}
                        className="flex gap-3 border-b p-4 last:border-b-0 sm:border-b-0"
                    >
                        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                            <Icon className="h-4 w-4" />
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold">
                                {benefit.title}
                            </h3>
                            <p className="mt-1 text-xs leading-5 text-muted-foreground">
                                {benefit.description}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    </section>
);
